import { writable } from 'svelte/store';
import type { Preferences, ThemeId } from '$lib/domain/types';
import { DEFAULT_THEME, normalizePreferences } from '$lib/domain/preferences';
import { preferencesRepo } from '$lib/db/repo';
import { syncEngine } from './sync';

const createPreferencesStore = () => {
  const { subscribe, set, update } = writable<Preferences>({ theme: DEFAULT_THEME });

  const load = async () => {
    const prefs = await preferencesRepo.get();
    set(normalizePreferences(prefs));
  };

  const setTheme = async (theme: ThemeId) => {
    update((current) => {
      const next = normalizePreferences({ ...current, theme });
      preferencesRepo.set(next);
      syncEngine.enqueueChange('preferences', 'default', { key: 'default', value: next });
      return next;
    });
  };

  return { subscribe, load, setTheme };
};

export const preferencesStore = createPreferencesStore();
